
import { Component, Vue } from 'nuxt-property-decorator'
import BPSection from './snippets/BPSection.vue'
import BPSectionHeader from './snippets/BPSectionHeader.vue'

import IconCopy from './icons/IconCopy.vue'
import IconTimer from './icons/IconTimer.vue'
import IconStar from './icons/IconStar2.vue'
import IconGift from './icons/IconGift.vue'
import IconHeadset from './icons/IconHeadset.vue'
import IconStorefront from './icons/IconStorefront.vue'
import BPWhyAlaoGridItem from '~/components/promos/black-promo/BPWhyAlao/BPWhyAlaoGridItem.vue'
import BPWhyAlaoGrid from '~/components/promos/black-promo/BPWhyAlao/BPWhyAlaoGrid.vue'

@Component({
  components: {
    BPSection,
    BPSectionHeader,
    BPWhyAlaoGrid,
    BPWhyAlaoGridItem,
  },
})
export default class BPWhyAlao extends Vue {
  get items () {
    return [
      {
        icon: IconCopy,
        title: this.$t('blackSeptember.whyAlao.grid.item1.title'),
        text: this.$t('blackSeptember.whyAlao.grid.item1.text'),
      },
      {
        icon: IconTimer,
        title: this.$t('blackSeptember.whyAlao.grid.item2.title'),
        text: this.$t('blackSeptember.whyAlao.grid.item2.text'),
      },
      {
        icon: IconStar,
        title: this.$t('blackSeptember.whyAlao.grid.item3.title'),
        text: this.$t('blackSeptember.whyAlao.grid.item3.text'),
      },
      {
        icon: IconGift,
        title: this.$t('blackSeptember.whyAlao.grid.item4.title'),
        text: this.$t('blackSeptember.whyAlao.grid.item4.text'),
      },
      {
        icon: IconHeadset,
        title: this.$t('blackSeptember.whyAlao.grid.item5.title'),
        text: this.$t('blackSeptember.whyAlao.grid.item5.text'),
      },
      {
        icon: IconStorefront,
        title: this.$t('blackSeptember.whyAlao.grid.item6.title'),
        text: this.$t('blackSeptember.whyAlao.grid.item6.text'),
      },
    ]
  }
}
